import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceMerchantActions from '../actions/ecommerce-create-merchant.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {EcommercePaymentsService} from "../../websites/website/ecommerce/ecommerce-payments.service";
import {LoadEcommerceActiveMerchant, LoadEcommerceMerchantHash, LoadEcommerceWorkspaceMerchants} from "../actions";
import {MerchantMapper} from "../../websites/website/ecommerce/payment-management/merchant-mapper";
import {LoadEcommerceMerchantPayoutsAmount} from "../actions/ecommerce-create-merchant.action";

@Injectable()
export class EcommerceMerchantEffect {

  /*loadEcommerceMerchant = createEffect(() => this._actions$.pipe(
    ofType(EcommerceMerchantActions.LOAD_ECOMMERCE_MERCHANT),
    mergeMap((action: LoadEcommerceMerchant) => {
      const {websiteId} = action.payload;
      const env = action?.payload?.env;
      // @ts-ignore
      return this._ecommercePaymentsService.createStripeAccount(env)
        .pipe(
          filter((response: DbResponse) => !!response),
          // @ts-ignore
          switchMap((response: DbResponse) => {
            if (response && response.response?.body?.data?.merchant_id) {
              const merchantId = response.response.body.data.merchant_id;
              return new EcommerceMerchantActions.LoadEcommerceMerchantSuccess({
                merchantId: merchantId,
                websiteId: websiteId,
                loaded: true
              });
            }
            else {
              // Immediately return a fail action if no merchant_id
              return new EcommerceMerchantActions.LoadEcommerceMerchantFail({websiteId});
            }
          })
        );
    })
  ));*/

  loadEcommerceActiveMerchant = createEffect(() => this._actions$.pipe(
    ofType(EcommerceMerchantActions.LOAD_ECOMMERCE_ACTIVE_MERCHANT),
    mergeMap((action: LoadEcommerceActiveMerchant) => {
      const {websiteId} = action.payload;
      // @ts-ignore
      return this._ecommercePaymentsService.getStripeAccount(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response && response.data) {
              return new EcommerceMerchantActions.LoadEcommerceActiveMerchantSuccess({
                merchant: response.data,
                websiteId: websiteId,
                loaded: true
              });
            }
            // This fail action might never be dispatched if above conditions are always met or if error handling is done elsewhere
            return new EcommerceMerchantActions.LoadEcommerceActiveMerchantFail({websiteId});
          })
        );
    })
  ));


  loadEcommerceWorkspaceMerchants = createEffect(() => this._actions$.pipe(
    ofType(EcommerceMerchantActions.LOAD_ECOMMERCE_WORKSPACE_MERCHANTS),
    mergeMap((action: LoadEcommerceWorkspaceMerchants) => {
      return this._ecommercePaymentsService.getWorkspaceMerchants()
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response && response.data) {
              return new EcommerceMerchantActions.LoadEcommerceWorkspaceMerchantsSuccess({
                merchants: response.data.map(MerchantMapper.map),
                loaded: true
              });
            }
            // This fail action might never be dispatched if above conditions are always met or if error handling is done elsewhere
            return new EcommerceMerchantActions.LoadEcommerceWorkspaceMerchantsFail({});
          })
        );
    })
  ));


  loadEcommerceMerchantHash = createEffect(() => this._actions$.pipe(
    ofType(EcommerceMerchantActions.LOAD_ECOMMERCE_MERCHANT_HASH),
    mergeMap((action: LoadEcommerceMerchantHash) => {
      const {websiteId} = action.payload;
      return this._ecommercePaymentsService.createAccountSession(action?.payload?.env, action?.payload?.merchantId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response && response.data) {
              return new EcommerceMerchantActions.LoadEcommerceMerchantHashSuccess({
                existingMerchantHash: response.data,
                websiteId: websiteId,
                loaded: true
              });
            }
            // This fail action might never be dispatched if above conditions are always met or if error handling is done elsewhere
            return new EcommerceMerchantActions.LoadEcommerceMerchantHashFail({websiteId});
          })
        );
    })
  ));


  loadEcommerceMerchantPayoutsAmount = createEffect(() => this._actions$.pipe(
    ofType(EcommerceMerchantActions.LOAD_ECOMMERCE_MERCHANT_PAYOUTS_AMOUNT),
    mergeMap((action: LoadEcommerceMerchantPayoutsAmount) => {
      const {websiteId} = action.payload;
      return this._ecommercePaymentsService.getDomainPendingPayouts(action?.payload?.merchantId, action?.payload?.env)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response && response.data) {
              return new EcommerceMerchantActions.LoadEcommerceMerchantPayoutsAmountSuccess({
                payoutsAmount: response?.data?.pending_payout_amount,
                websiteId: websiteId,
                loaded: true
              });
            }
            // This fail action might never be dispatched if above conditions are always met or if error handling is done elsewhere
            return new EcommerceMerchantActions.LoadEcommerceMerchantPayoutsAmountFail({websiteId});
          })
        );
    })
  ));


  constructor(
    private _actions$: Actions,
    private _ecommercePaymentsService: EcommercePaymentsService,
  ) {
  }

}
